import ChargeDriverListView from 'features/Charge/ChargeDriver/components/ChargeDriverListView';

FleetDriverListScreen.propTypes = {};

function FleetDriverListScreen(props) {
    // MARK: ---- PROPERTIES ----

    return (
        <div>
            <div className="container-fluid px-4 my-4">
                <ChargeDriverListView isFleetDriver={true} />
            </div>
        </div>
    );
}

export default FleetDriverListScreen;
